define(["exports", "./utils", "text!../../assets/issues-notes.css", "../core/l10n", "hyperhtml", "./pubsubhub"], function (_exports, _utils, _issuesNotes, _l10n, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _issuesNotes = _interopRequireDefault(_issuesNotes);
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject11() {
    const data = _taggedTemplateLiteral(["<style>", "</style>"]);

    _templateObject11 = function _templateObject11() {
      return data;
    };

    return data;
  }

  function _templateObject10() {
    const data = _taggedTemplateLiteral(["<a\n    class=\"", "\"\n    style=\"", "\"\n    href=\"", "\">", "</a>"]);

    _templateObject10 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9() {
    const data = _taggedTemplateLiteral(["<span class=\"issue-label\">: ", "", "</span>"]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["<span\n      class=\"issue-label\"\n      aria-label=\"", "\">: ", "", "</span>"]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["<p>", "</p>"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n    <li><a href=\"", "\">", "</a>", "</li>\n  "]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<span style=\"text-transform: none\">: ", "</span>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<a href='", "'/>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["<a href='", "'/>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n        <div role='heading' class='", "'>", "</div>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<div class=\"", "\" role=\"", "\"></div>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/issues-notes";
  _exports.name = name;
  const localizationStrings = {
    en: {
      issue_summary: "Issue Summary",
      no_issues_in_spec: "There are no issues listed in this specification."
    },
    nl: {
      issue_summary: "Lijst met issues",
      no_issues_in_spec: "Er zijn geen problemen vermeld in deze specificatie."
    },
    es: {
      issue_summary: "Resumen de la cuestión",
      no_issues_in_spec: "No hay problemas enumerados en esta especificación."
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];
  /**
   * @typedef {object} Report
   * @property {string} type
   * @property {boolean} inline
   * @property {number} number
   * @property {string} title
  
   * @typedef {object} GitHubLabel
   * @property {string} color
   * @property {string} name
   *
   * @typedef {object} GitHubIssue
   * @property {string} title
   * @property {string} state
   * @property {string} bodyHTML
   * @property {GitHubLabel[]} labels
  
   * @param {NodeListOf<HTMLElement>} ins
   * @param {Map<string, GitHubIssue>} ghIssues
   * @param {*} conf
   */

  function handleIssues(ins, ghIssues, conf) {
    const hasDataNum = !!document.querySelector(".issue[data-number]");
    let issueNum = 0;
    const issueList = document.createElement("ul");
    ins.forEach(inno => {
      const {
        type,
        displayType,
        isFeatureAtRisk
      } = getIssueType(inno, conf);
      const isIssue = type === "issue";
      const isInline = inno.localName === "span";
      const {
        number: dataNum
      } = inno.dataset;
      /** @type {Partial<Report>} */

      const report = {
        type,
        inline: isInline,
        title: inno.title
      };

      if (isIssue && !isInline && !hasDataNum) {
        issueNum++;
        report.number = issueNum;
      } else if (dataNum) {
        report.number = Number(dataNum);
      } // wrap


      if (!isInline) {
        const cssClass = isFeatureAtRisk ? "".concat(type, " atrisk") : type;
        const ariaRole = type === "note" ? "note" : null;
        const div = (0, _hyperhtml.default)(_templateObject(), cssClass, ariaRole);
        const title = document.createElement("span");
        const titleParent = (0, _hyperhtml.default)(_templateObject2(), "".concat(type, "-title marker"), title);
        (0, _utils.addId)(titleParent, "h", type);
        let text = displayType;

        if (inno.id) {
          div.id = inno.id;
          inno.removeAttribute("id");
        } else {
          (0, _utils.addId)(div, "issue-container", report.number ? "number-".concat(report.number) : "");
        }
        /** @type {GitHubIssue} */


        let ghIssue;

        if (isIssue) {
          if (!hasDataNum) {
            text += " ".concat(issueNum);
          } else if (dataNum) {
            text += " ".concat(dataNum);
            const link = linkToIssueTracker(dataNum, conf, {
              isFeatureAtRisk
            });

            if (link) {
              title.before(link);
              link.append(title);
            }

            title.classList.add("issue-number");
            ghIssue = ghIssues.get(dataNum);

            if (!ghIssue) {
              (0, _pubsubhub.pub)("warning", "Failed to fetch issue number ".concat(dataNum));
            }

            if (ghIssue && !report.title) {
              report.title = ghIssue.title;
            }
          }

          if (report.number !== undefined) {
            // Add entry to #issue-summary.
            issueList.append(createIssueSummaryEntry(conf.l10n.issue, report, div.id));
          }
        }

        title.textContent = text;

        if (report.title) {
          inno.removeAttribute("title");
          const {
            repoURL = ""
          } = conf.github || {};
          const labels = ghIssue ? ghIssue.labels : [];

          if (ghIssue && ghIssue.state === "CLOSED") {
            div.classList.add("closed");
          }

          titleParent.append(createLabelsGroup(labels, report.title, repoURL));
        }
        /** @type {HTMLElement | DocumentFragment} */


        let body = inno;
        inno.replaceWith(div);
        body.classList.remove(type);
        body.removeAttribute("data-number");

        if (ghIssue && !body.innerHTML.trim()) {
          body = document.createRange().createContextualFragment(ghIssue.bodyHTML);
        }

        div.append(titleParent, body);
        const level = (0, _utils.parents)(titleParent, "section").length + 2;
        titleParent.setAttribute("aria-level", level);
      }

      (0, _pubsubhub.pub)(report.type, report);
    });
    makeIssueSectionSummary(issueList);
  }
  /**
   * @typedef {object} IssueType
   * @property {string} type
   * @property {string} displayType
   * @property {boolean} isFeatureAtRisk
   *
   * @param {HTMLElement} inno
   * @return {IssueType}
   */


  function getIssueType(inno, conf) {
    const isIssue = inno.classList.contains("issue");
    const isWarning = inno.classList.contains("warning");
    const isEdNote = inno.classList.contains("ednote");
    const isFeatureAtRisk = inno.classList.contains("atrisk");
    const type = isIssue ? "issue" : isWarning ? "warning" : isEdNote ? "ednote" : "note";
    const displayType = isIssue ? isFeatureAtRisk ? conf.l10n.feature_at_risk : conf.l10n.issue : isWarning ? conf.l10n.warning : isEdNote ? conf.l10n.editors_note : conf.l10n.note;
    return {
      type,
      displayType,
      isFeatureAtRisk
    };
  }
  /**
   * @param {string} dataNum
   * @param {*} conf
   */


  function linkToIssueTracker(dataNum, conf, {
    isFeatureAtRisk = false
  } = {}) {
    // Set issueBase to cause issue to be linked to the external issue tracker
    if (!isFeatureAtRisk && conf.issueBase) {
      return (0, _hyperhtml.default)(_templateObject3(), conf.issueBase + dataNum);
    } else if (isFeatureAtRisk && conf.atRiskBase) {
      return (0, _hyperhtml.default)(_templateObject4(), conf.atRiskBase + dataNum);
    }
  }
  /**
   * @param {string} l10nIssue
   * @param {Partial<Report>} report
   */


  function createIssueSummaryEntry(l10nIssue, report, id) {
    const issueNumberText = "".concat(l10nIssue, " ").concat(report.number);
    const title = report.title ? (0, _hyperhtml.default)(_templateObject5(), report.title) : "";
    return (0, _hyperhtml.default)(_templateObject6(), "#".concat(id), issueNumberText, title);
  }
  /**
   *
   * @param {HTMLUListElement} issueList
   */


  function makeIssueSectionSummary(issueList) {
    const issueSummaryElement = document.getElementById("issue-summary");
    if (!issueSummaryElement) return;
    const heading = issueSummaryElement.querySelector("h2, h3, h4, h5, h6");
    issueList.hasChildNodes() ? issueSummaryElement.append(issueList) : issueSummaryElement.append((0, _hyperhtml.default)(_templateObject7(), l10n.no_issues_in_spec));

    if (!heading || heading && heading !== issueSummaryElement.firstElementChild) {
      issueSummaryElement.insertAdjacentHTML("afterbegin", "<h2>".concat(l10n.issue_summary, "</h2>"));
    }
  }

  function isLight(rgb) {
    const red = rgb >> 16 & 0xff;
    const green = rgb >> 8 & 0xff;
    const blue = rgb >> 0 & 0xff;
    const illumination = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
    return illumination > 140;
  }
  /**
   * @param {GitHubLabel[]} labels
   * @param {string} title
   * @param {string} repoURL
   */


  function createLabelsGroup(labels, title, repoURL) {
    const labelsGroup = labels.map(label => createLabel(label, repoURL));
    const labelNames = labels.map(label => label.name);
    const joinedNames = (0, _utils.joinAnd)(labelNames);

    if (labelsGroup.length) {
      labelsGroup.unshift(document.createTextNode(" "));
    }

    if (labelNames.length) {
      const ariaLabel = "This issue is labelled as ".concat(joinedNames, ".");
      return (0, _hyperhtml.default)(_templateObject8(), ariaLabel, title, labelsGroup);
    }

    return (0, _hyperhtml.default)(_templateObject9(), title, labelsGroup);
  }
  /**
   * @param {GitHubLabel} label
   * @param {string} repoURL
   */


  function createLabel(label, repoURL) {
    const {
      color,
      name
    } = label;
    const issuesURL = new URL("./issues/", repoURL);
    issuesURL.searchParams.set("q", "is:issue is:open label:\"".concat(label.name, "\""));
    const rgb = parseInt(color, 16);
    const textColorClass = isNaN(rgb) || isLight(rgb) ? "light" : "dark";
    const cssClasses = "respec-gh-label respec-label-".concat(textColorClass);
    const style = "background-color: #".concat(color);
    return (0, _hyperhtml.default)(_templateObject10(), cssClasses, style, issuesURL.href, name);
  }
  /**
   * @param {string} githubAPI
   * @returns {Promise<Map<string, GitHubIssue>>}
   */


  async function fetchAndStoreGithubIssues(githubAPI) {
    if (!githubAPI) {
      return new Map();
    }
    /** @type {NodeListOf<HTMLElement>} */


    const specIssues = document.querySelectorAll(".issue[data-number]");
    const issueNumbers = [...specIssues].map(elem => Number.parseInt(elem.dataset.number, 10)).filter(issueNumber => issueNumber);

    if (!issueNumbers.length) {
      return new Map();
    }

    const url = new URL("issues", githubAPI);
    url.searchParams.set("issues", issueNumbers.join(","));
    const response = await fetch(url.href);

    if (!response.ok) {
      const msg = "Error fetching issues from GitHub. (HTTP Status ".concat(response.status, ").");
      (0, _pubsubhub.pub)("error", msg);
      return new Map();
    }
    /** @type {{ [issueNumber: string]: GitHubIssue }} */


    const issues = await response.json();
    return new Map(Object.entries(issues));
  }

  async function run(conf) {
    const query = ".issue, .note, .warning, .ednote";
    /** @type {NodeListOf<HTMLElement>} */

    const issuesAndNotes = document.querySelectorAll(query);

    if (!issuesAndNotes.length) {
      return; // nothing to do.
    }

    const ghIssues = await fetchAndStoreGithubIssues(conf.githubAPI);
    const {
      head: headElem
    } = document;
    headElem.insertBefore((0, _hyperhtml.default)(_templateObject11(), [_issuesNotes.default]), headElem.querySelector("link"));
    handleIssues(issuesAndNotes, ghIssues, conf);
    const ednotes = document.querySelectorAll(".ednote");
    ednotes.forEach(ednote => {
      ednote.classList.remove("ednote");
      ednote.classList.add("note");
    });
  }
});
//# sourceMappingURL=issues-notes.js.map